/**
 * Default price range values for rental listings (in dollars)
 */
export const DEFAULT_PRICE_RANGE_VALUES = [
    1000, 1500, 2000, 2500, 3000, 3500, 4000, 4500, 5000, 6000, 7000, 8000, 10000,
];
/**
 * Snaps an arbitrary dollar amount up to the closest selectable max-price value.
 * Returns `undefined` for amounts above the top of the range, which the filter
 * has no way to express.
 */
export function roundUpToPriceRangeValue(amount) {
    return DEFAULT_PRICE_RANGE_VALUES.find(value => value >= amount);
}
/**
 * Creates formatted price range options from values
 */
export function createPriceRangeOptions() {
    return DEFAULT_PRICE_RANGE_VALUES.map(value => ({
        value,
        label: `$${value.toLocaleString()}`,
    }));
}
